import { FunctionComponent } from 'react';
import { Backdrop, DialogAlert, ButtonTertiary, ButtonPrimary, Type } from '@spotify-internal/encore-web';
import { useTranslation } from 'react-i18next';

export type WarningDialogProps = {
  uris?: string[];
  onClickClose: () => void;
  onClickContinue?: () => void;
  labels: {
    reason: string;
    title?: string;
    close?: string;
    continue?: string;
  };
};

const WarningDialog: FunctionComponent<WarningDialogProps> = props => {
  const { uris = [], onClickClose, onClickContinue, labels } = props;

  const { t } = useTranslation(['infringement_claim_form', 'content_policy_reporting']);

  const dialogTitle = !!labels.title && `${t(labels.title)}:`;

  return (
    <Backdrop center>
      <DialogAlert
        colorSet="invertedLight"
        dialogTitle={dialogTitle}
        body={
          <>
            {!!uris.length && <Type.p as="p">{uris.map(uri => `${uri}\n`)}</Type.p>}
            <Type.p>{`${t('reason')}:`}</Type.p>
            <Type.p>{t(labels.reason)}</Type.p>
          </>
        }
        footer={
          <>
            <ButtonTertiary condensed onClick={onClickClose} id="close-unresolved-uri-dialog">
              {t(labels.close || 'back_button_label')}
            </ButtonTertiary>
            {onClickContinue && (
              <ButtonPrimary onClick={onClickContinue} id="continue-without">
                {t(labels.continue || 'resolve_uri_not_found_dialog_continue_without')}
              </ButtonPrimary>
            )}
          </>
        }
        id="dialogConfirmation"
      />
    </Backdrop>
  );
};

export default WarningDialog;
